<template>
  <page-banner
    :src="bannerSrc"
    alt="懂标帝平价商标交易平台"
    auto-height
    content-align="end"
    safe-bottom
  >
    <div class="hero-banner__text">
      <h1 class="hero-banner__title">懂标帝平价商标交易平台</h1>
      <p class="hero-banner__subtitle">平台直营 · 安全交易 · 全网低价</p>

      <form class="hero-search" @submit.prevent="handleSearch">
        <input
          v-model="keyword"
          type="search"
          class="hero-search__input"
          :placeholder="searchPlaceholder"
          @keyup.enter="handleSearch"
        />
        <button type="submit" class="hero-search__btn">搜索商标</button>
      </form>

      <div class="hero-search__hot">
        <span class="hero-search__hot-label">热门搜索：</span>
        <button
          v-for="item in hotSearchItems"
          :key="item.label"
          type="button"
          class="hero-search__hot-btn"
          @click="handleHotSearch(item)"
        >{{ item.label }}</button>
      </div>
    </div>
  </page-banner>
</template>

<script>
import PageBanner from '@/components/common/PageBanner.vue'
import { HOT_SEARCH_ITEMS, SEARCH_PLACEHOLDER } from '@/constants/search'

export default {
  name: 'HeroBanner',
  components: { PageBanner },
  data() {
    return {
      bannerSrc: require('@homepage/cdc08482cd0516280d683276c485181f.jpg'),
      keyword: '',
      hotSearchItems: HOT_SEARCH_ITEMS,
      searchPlaceholder: SEARCH_PLACEHOLDER
    }
  },
  methods: {
    handleSearch() {
      this.$emit('search', {
        keyword: this.keyword.trim(),
        category: ''
      })
    },
    handleHotSearch(item) {
      this.keyword = ''
      this.$emit('search', {
        keyword: '',
        category: item.category
      })
    }
  }
}
</script>

<style scoped>
.hero-banner__text {
  min-width: 0;
  margin-bottom: var(--banner-hero-content-lift);
}

.hero-banner__title {
  font-size: var(--font-size-hero);
  font-weight: 700;
  color: var(--color-text-inverse);
  line-height: 1.2;
  letter-spacing: 2px;
  white-space: nowrap;
}

.hero-banner__subtitle {
  margin-top: var(--space-md);
  font-size: var(--font-size-xl);
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 1px;
}

.hero-search {
  margin-top: var(--space-lg);
  display: flex;
  width: 100%;
  max-width: var(--search-bar-max-width);
  height: var(--search-bar-height);
  background: var(--color-bg-page);
  border-radius: var(--radius-pill);
  overflow: hidden;
  box-shadow: var(--shadow-panel);
}

.hero-search__input {
  flex: 1;
  min-width: 0;
  border: none;
  padding: 0 var(--space-lg);
  font-size: var(--font-size-md);
  color: var(--color-text-primary);
  outline: none;
  background: transparent;
}

.hero-search__input::placeholder {
  color: var(--color-text-muted);
}

.hero-search__btn {
  flex-shrink: 0;
  min-width: var(--search-btn-min-width);
  border: none;
  background: var(--color-primary);
  color: var(--color-text-inverse);
  font-size: var(--font-size-md);
  cursor: pointer;
  transition: background-color 0.2s;
}

.hero-search__btn:hover {
  background: var(--color-primary-dark);
}

.hero-search__hot {
  margin-top: var(--space-md);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-sm) var(--space-md);
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.88);
}

.hero-search__hot-label {
  flex-shrink: 0;
}

.hero-search__hot-btn {
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.92);
  font-size: var(--font-size-sm);
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}

.hero-search__hot-btn:hover {
  color: var(--color-text-inverse);
  text-decoration: underline;
}
</style>
